import { render, staticRenderFns } from "./ProfileEdit.vue?vue&type=template&id=2230df9f"
import script from "./ProfileEdit.vue?vue&type=script&lang=js"
export * from "./ProfileEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports